import { Box, Button, Typography } from '@mui/material';
import { loginSuccess } from '../../store/Slices/authSlice';
import { useState } from 'react';
import { toast } from 'react-toastify';
import AuthServices from '../../services/auth.services';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import OTPInput from 'react-otp-input';
import { onlyShowLastDigits } from '../../helpers/serviceHelpers';

function OTPForm({ number }: { number: string }) {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleVerifyOTP = async () => {
    try {
      setLoading(true);
      if (otp?.trim()?.length !== 6) return toast.warn('Invalid OTP');
      const token = await AuthServices.verifyOTP(number, otp);
      if (token) {
        dispatch(loginSuccess({ userId: number, token: token }));
        navigate('/');
      } else {
        toast.error('Could not verify the OTP');
      }
    } catch (error) {
      console.log(error);
      toast.error('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, py: 3 }}>
      <Typography>
        We texted your phone {onlyShowLastDigits(number.toString(), 4)}. Please enter the code to
        sign in.
      </Typography>
      <div className="self-center my-5">
        <OTPInput
          value={otp}
          onChange={setOtp}
          numInputs={6}
          renderSeparator={<span className="mx-1">-</span>}
          renderInput={(props) => (
            <input {...props} className="min-h-10 min-w-10 border border-[#000] rounded-md" />
          )}
        />
      </div>
      <Button
        onClick={handleVerifyOTP}
        disabled={otp?.trim()?.length !== 6 || loading}
        variant="contained"
        size="large"
        sx={{
          borderRadius: 10,
          alignSelf: 'end',
          color: 'white',
          ':disabled': {
            color: '#fff',
            bgcolor: '#000',
          },
          textTransform: 'none',
        }}
      >
        Verify OTP
      </Button>
    </Box>
  );
}

export { OTPForm };
